import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const SloveniaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'SI',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Slovenia',
  SHORT_NAME: 'SI',

  DISPLAY_NAME: 'Slovenia (English)',
  DISPLAY_COUNTRY: 'Slovenia (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 46.1433951,
    INITIAL_LONGITUDE: 13.6669749,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Carinthia',
    '2': 'Central Sava',
    '3': 'Central Slovenia',
    '4': 'Coastal–Karst',
    '5': 'Drava',
    '6': 'Gorizia',
    '7': 'Littoral–Inner Carniola',
    '8': 'Lower Sava',
    '9': 'Mura',
    '10': 'Savinja',
    '11': 'Southeast Slovenia',
    '12': 'Upper Carniola',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-si/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-si/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default SloveniaLocale
